import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Typography} from '@mui/material';
import BulkUploadActionsMenu from './BulkUploadActionsMenu';
import CustomPagination from '../../../components/customPagination';
import dayjs from 'dayjs';
import { useGetBulkUploadsHandler } from '../dataHandlers/getBulkUploadsHandler';
import DocumentTableStatusChip from "../../common/DocumentTableStatusChip";
import FileNameCard from "../../common/FileNameCard";
import BulkUploadProcessedStatusBar from "./BulkUploadProcessedStatusBar";
import {useQuery} from "@tanstack/react-query";
import {fetchUser} from "../../settings/dataHandlers/getUserHandler";
import Tooltip from "@mui/material/Tooltip";

const bulkUploadCategoryMapping = {
  "E_INVOICE": { "SALES": 'Sales Document', "PURCHASES": 'Purchase Document' },
};

const CreatedByCell = ({ userId }) => {
  const {
    data: user,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["auth-user", userId],
    queryFn: () => fetchUser(userId),
    enabled: Boolean(userId),
    refetchOnWindowFocus: false,
    retry: false,
  });
console.log(userId);
  if (!userId) {
    return "-";
  }

  if (isLoading) {
    return "Loading...";
  }

  if (isError) {
    return "-";
  }

  return user?.name || user?.email || "-";
};
const BulkUploadTable = ({ handlePaginationChange, searchQuery }) => {
  const { bulkUploads, totalDocuments, isLoading } = useGetBulkUploadsHandler({ searchQuery });

  const columns = [
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.8,
      id: 'bulk-upload-status',
      renderCell: (params) => {
        return <DocumentTableStatusChip status={params?.row?.status} />;
      },
    },
    {
      field: 'created_on',
      headerName: 'Upload Time',
      flex: 1.2,
      valueFormatter: (params) => {
        const timestamp = params;
        if (!timestamp) return '';
        return dayjs(timestamp).format('DD-MM-YYYY hh:mm:ss A');
      },
    },
    {
      field: 'category',
      headerName: 'Category',
      flex: 0.7,
      renderCell: (params) => {
        const category = params?.row?.category;
        const subCategory = params?.row?.sub_category;
        return bulkUploadCategoryMapping[category][subCategory];
      },
    },
    {
      field: 'filename',
      headerName: 'File',
      flex: 1.4,
      renderCell: (params) => {
        return <FileNameCard fileName={params?.row?.filename} defaultTemplate={params?.row?.template_name} />
      }
    },
    {
      field: 'processed_documents_count',
      headerName: 'Processed Status',
      flex: 0.8,
      renderCell: ({ row }) => {
        return <BulkUploadProcessedStatusBar currentStatus={row?.status} totalProcessedDocuments={row?.processed_documents_count} totalUploadedDocuments={row?.total_documents_count}/>;
      },
    },
    {
      field: 'created_by',
      headerName: 'Created By',
      flex: 1.4,
      renderCell: (params) => <CreatedByCell userId={params?.row?.user_id} />,
    },
    {
      field: 'row',
      headerName: 'Actions',
      flex: 0.5,
      sortable: false,
      renderCell: ({ row }) => <BulkUploadActionsMenu row={row} />,
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={[...bulkUploads].sort((a, b) => {
          const dateA = new Date(a.created_on).toLocaleString();
          const dateB = new Date(b.created_on).toLocaleString();
          return new Date(dateB).getTime() - new Date(dateA).getTime();
        })}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default BulkUploadTable;
